var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSortie(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 32,
    height: 32,
    transform: "translate(0 0)",
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_14",
    "data-name": "Groupe 14",
    transform: "translate(0.215 0.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_13",
    "data-name": "Groupe 13",
    transform: "translate(-0.215 -0.215)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1",
    "data-name": "Trac\\xE9 1",
    d: "M11.032,31.912h-.81c-.186-.058-.372-.114-.557-.176-2.592-.862-5.186-1.72-7.776-2.591A2.636,2.636,0,0,1,.057,27.129.926.926,0,0,0,0,26.988V2.244c.026-.075.056-.15.077-.227A2.669,2.669,0,0,1,1.81.14C1.953.088,2.1.046,2.244,0h15.52c.079.021.156.049.236.063a3.951,3.951,0,0,1,3.244,3.55c.056,1.483.021,2.97.017,4.456a1.177,1.177,0,0,1-.482.939,1.263,1.263,0,0,1-1.376.177,1.23,1.23,0,0,1-.778-1.177c-.01-1.278,0-2.555-.005-3.833a1.349,1.349,0,0,0-1.492-1.51q-2.774,0-5.547,0c-.09,0-.179.008-.28.013.022.032.028.055.042.061a2.705,2.705,0,0,1,1.948,2.944q0,9.583,0,19.166v.411H17.08A1.364,1.364,0,0,0,18.62,23.7q0-2.462,0-4.924a2.056,2.056,0,0,1,.049-.524,1.318,1.318,0,0,1,1.391-.962,1.292,1.292,0,0,1,1.2,1.287q.019,2.664,0,5.329a3.97,3.97,0,0,1-4.043,4.015c-1.195,0-2.389,0-3.584,0h-.354c0,.514.013.981,0,1.446a2.414,2.414,0,0,1-1.052,1.989,7.336,7.336,0,0,1-1.2.554",
    transform: "translate(0.088 0.088)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2",
    "data-name": "Trac\\xE9 2",
    d: "M292.013,113.581a8.625,8.625,0,0,1-.732.981c-1.618,1.642-3.256,3.265-4.884,4.9a1.368,1.368,0,0,1-1.262.455,1.319,1.319,0,0,1-1.1-1.352c-.006-1.184,0-2.368,0-3.552v-.386h-.377c-1.61,0-3.22,0-4.83,0a1.339,1.339,0,0,1-1.41-1.069,1.318,1.318,0,0,1,1.341-1.593c1.631-.006,3.261,0,4.892,0h.384v-.344c0-1.174,0-2.347,0-3.521a1.343,1.343,0,0,1,2.353-.985c1.723,1.728,3.455,3.448,5.17,5.185a3.907,3.907,0,0,1,.457.725Z",
    transform: "translate(-260.012 -99.905)",
    fill: "#currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortie);
export default __webpack_public_path__ + "static/media/sortie.5139e7b41d82b4ea0dfbe8ca20f5682a.svg";
export { ForwardRef as ReactComponent };